module.exports = __webpack_public_path__ + "img/tipp-up.b5dc0cb7.svg";